const config3ColumnLinks = {
  col1Label: 'BROWSE SERVICES',
  col1Links: [
    {
      external: true,
      label: 'Births, relationships and deaths',
      link: 'https://www.service.nsw.gov.au/services/births-relationships-and-deaths'
    },
    {
      external: true,
      label: 'Boating, fishing and outdoors',
      link: 'https://www.service.nsw.gov.au/services/boating-fishing-and-outdoors'
    },
    {
      external: true,
      label: 'Business, industries and employment',
      link: 'https://www.service.nsw.gov.au/services/business-industries-and-employment'
    },
    {
      external: true,
      label: 'Concessions, rebates and assistance',
      link: 'https://www.service.nsw.gov.au/services/concessions-rebates-and-assistance'
    },
    {
      external: true,
      label: 'Driving and transport',
      link: 'https://www.service.nsw.gov.au/services/driving-and-transport'
    },
    {
      external: true,
      label: 'Education',
      link: 'https://www.service.nsw.gov.au/services/education'
    },
    {
      external: true,
      label: 'Health and care',
      link: 'https://www.service.nsw.gov.au/services/health-and-care'
    },
    {
      external: true,
      label: 'Housing and property',
      link: 'https://www.service.nsw.gov.au/services/housing-and-property'
    },
    {
      external: true,
      label: 'Legal and Police services',
      link: 'https://www.service.nsw.gov.au/services/legal-and-police-services'
    }
  ],
  col2Label: 'SERVICE NSW',
  col2Links: [
    {
      external: true,
      label: 'About us',
      link: 'https://www.service.nsw.gov.au/about-us'
    },
    {
      external: true,
      label: 'Jobs at Service NSW',
      link: 'https://www.service.nsw.gov.au/about-us/jobs-service-nsw'
    },
    {
      external: true,
      label: 'News',
      link: 'https://www.service.nsw.gov.au/news'
    },
    {
      external: true,
      label: 'Download the Service NSW app',
      link: 'https://www.service.nsw.gov.au/campaign/service-nsw-mobile-app'
    },
    {
      external: true,
      label: 'Help in your language',
      link: 'https://www.service.nsw.gov.au/help-your-language'
    },
    {
      external: true,
      label: 'Service status',
      link: 'https://www.service.nsw.gov.au/service-status'
    },
    {
      external: true,
      label: 'Performance dashboard',
      link: 'https://www.service.nsw.gov.au/performance-dashboard'
    }
  ],
  col3Label: 'CONTACT',
  col3Links: [
    {
      external: true,
      label: 'Contact form',
      link: 'https://www.pharmacycouncil.nsw.gov.au/privacy-policy'
    },
    {
      label: 'Phone 13 77 88',
      phone: '137788',
      type: 'phone'
    },
    {
      external: true,
      label: 'Find a Service NSW location',
      link: 'https://www.service.nsw.gov.au/service-centre'
    },
    {
      external: true,
      label: 'Find a NSW Government agency',
      link: 'https://www.service.nsw.gov.au/nswgovdirectory'
    }
  ]
};

const configFooterLinks = [
  {
    external: true,
    label: 'Accessibility',
    link: 'https://www.service.nsw.gov.au/accessibility'
  },
  {
    external: true,
    label: 'Privacy',
    link: 'https://www.service.nsw.gov.au/privacy'
  },
  {
    external: true,
    label: 'Terms of use',
    link: 'https://www.service.nsw.gov.au/terms-use'
  },
  {
    external: true,
    label: 'Copyright and disclaimer',
    link: 'https://www.service.nsw.gov.au/copyright-and-disclaimer'
  },
  {
    external: true,
    label: 'Accessing information',
    link: 'https://www.service.nsw.gov.au/accessing-information'
  },
  {
    external: true,
    showExternalSVG: true,
    label: 'NSW Government',
    link: 'https://www.nsw.gov.au'
  }
];

export { config3ColumnLinks, configFooterLinks };
